import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Items from '../views/Items.vue';
import Item from '../views/Item.vue';
import Admin from '../views/Admin.vue';
import Edit from '../views/Edit.vue';

function patchRouterMethod(router, methodName) {
  // eslint-disable-next-line no-param-reassign
  router[`old${methodName}`] = router[methodName];
  // eslint-disable-next-line no-param-reassign
  router[methodName] = function (location) {
    return router[`old${methodName}`](location).catch((error) => {
      if (error.name === 'NavigationDuplicated') {
        return this.currentRoute;
      }
      throw error;
    });
  };
}

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/items',
    name: 'Items',
    component: Items,
  },
  {
    path: '/item/:item_id',
    name: 'Item',
    component: Item,
  },
  {
    path: '/admin/edit',
    name: 'Edit',
    component: Edit,
  },
  {
    path: '/admin/:action',
    name: 'Admin',
    component: Admin,
  },
  {
    path: '/admin/*',
    redirect: {
      name: 'Admin',
      params: {
        action: 'create',
      },
    },
  },
  {
    path: '/admin',
    redirect: {
      name: 'Admin',
      params: {
        action: 'create',
      },
    },
  },
  {
    path: '*',
    redirect: {
      name: 'Home',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

patchRouterMethod(router, 'push');
patchRouterMethod(router, 'replace');

export default router;
